import React, { useEffect, useState } from "react";
import TransactionDetails from "../../../components/Shared/TransactionDetails";
import { useSelector } from "react-redux";
import StepCompleted from "./StepCompleted";

const FifthStep = (formData, showPreviousButton) => {
  const certificationCreated = useSelector(
    (state) => state.createCommodity.data
  );
  const [isStepFinished, setIsStepFinished] = useState(false);

  useEffect(() => {
    if (certificationCreated) {
      setIsStepFinished(true);
      showPreviousButton(false);
    }
  }, [certificationCreated, showPreviousButton]);

  const stepDisplayed = isStepFinished ? (
    <StepCompleted />
  ) : (
    <div className="w-11/12 my-9 flex justify-center items-center">
      <div className="">
        <TransactionDetails certificationData={formData} />
      </div>
    </div>
  );
  return stepDisplayed;
};
export default FifthStep;
